import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredTabEmptyPlaceholderIcon = (props: IconProps) => (
  <Icon width="233px" height="238px" viewBox="0 0 233 238" {...props}>
    <defs>
      <ellipse
        id="path-1"
        cx="56.3736208"
        cy="56.4298719"
        rx="46.0225929"
        ry="46.1020896"
      />
      <ellipse
        id="path-3"
        cx="37.8651435"
        cy="37.9121937"
        rx="32.2595993"
        ry="32.3192037"
      />
      <ellipse
        id="path-5"
        cx="34.7092223"
        cy="34.7676047"
        rx="32.2575888"
        ry="32.3211926"
      />
      <path
        d="M1.78919299,3.88617905 C0.721192989,3.80117905 -0.0788070113,2.86217905 0.00619298865,1.79217905 C0.0901929887,0.723179049 1.02819299,-0.0788209511 2.09619299,0.00617904886 C3.16419299,0.0911790489 3.96319299,1.03017905 3.87819299,2.10017905 C3.79419299,3.17117905 2.85619299,3.97117905 1.78919299,3.88617905 Z M2.08119299,0.197179049 C1.11919299,0.121179049 0.273192989,0.843179049 0.197192989,1.80817905 C0.121192989,2.77217905 0.841192989,3.61917905 1.80419299,3.69517905 C2.76719299,3.77217905 3.61119299,3.05017905 3.68719299,2.08517905 C3.76419299,1.12117905 3.04319299,0.274179049 2.08119299,0.197179049 Z"
        id="path-7"
      />
      <path
        d="M1.78906097,3.88618584 C0.721060975,3.80118584 -0.077939025,2.86218584 0.00606097496,1.79218584 C0.091060975,0.722185837 1.02906097,-0.0788141633 2.09706097,0.0061858367 C3.16506097,0.0901858367 3.96406097,1.03018584 3.87906097,2.10018584 C3.79406097,3.17018584 2.85706097,3.97118584 1.78906097,3.88618584 Z M2.08106097,0.197185837 C1.11906097,0.121185837 0.274060975,0.843185837 0.198060975,1.80718584 C0.122060975,2.77218584 0.842060975,3.61818584 1.80406097,3.69418584 C2.76706097,3.77118584 3.61206097,3.04918584 3.68806097,2.08518584 C3.76506097,1.12118584 3.04306097,0.274185837 2.08106097,0.197185837 Z"
        id="path-9"
      />
      <polygon
        id="path-11"
        points="1.317 0.389 0.026 0.287 0 0.61 1.291 0.713"
      />
      <ellipse
        id="path-13"
        cx="25.9543324"
        cy="25.9979356"
        rx="24.1210916"
        ry="24.1685944"
      />
      <ellipse
        id="path-15"
        cx="23.6534815"
        cy="23.6767347"
        rx="19.2640918"
        ry="19.2971932"
      />
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group">
        <ellipse
          id="Oval"
          fill="#D6D6D6"
          fillRule="nonzero"
          opacity="0.5"
          cx="116.194"
          cy="121.2321"
          rx="116.194"
          ry="116.426"
        />
        <g id="Clipped" transform="translate(48.245770, 28.654948)">
          <mask id="mask-2" fill="white">
            <use
              xlinkHref="#path-1"
              transform="translate(56.373621, 56.429872) rotate(14.977368) translate(-56.373621, -56.429872) "
            />
          </mask>
          <g
            id="Oval"
            transform="translate(56.373621, 56.429872) rotate(14.977368) translate(-56.373621, -56.429872) "
          />
          <g id="Group" mask="url(#mask-2)" fillRule="nonzero">
            <g transform="translate(-30.913059, -20.701966)">
              <rect
                id="Rectangle"
                fill="#D9D9D9"
                transform="translate(110.547232, 107.722881) rotate(14.977368) translate(-110.547232, -107.722881) "
                x="19.422746"
                y="20.5899001"
                width="182.248972"
                height="174.265961"
              />
              <path
                d="M83.917289,58.5318182 C77.972789,56.9967182 69.750489,58.1621182 68.007589,68.1476182 C66.786089,75.1448182 65.306289,87.2831182 69.707889,88.8541182 C71.655089,89.5501182 79.140289,88.8991182 79.140289,88.8991182 L77.526489,97.2161182 L91.225289,97.2821182 L89.033289,85.3491182 C89.033289,85.3491182 103.507289,63.5917182 83.916289,58.5370182 L83.917289,58.5318182 Z"
                id="Path"
                fill="#FFEACC"
              />
              <path
                d="M72.397889,59.7915182 L81.332289,73.0783182 C82.942289,70.0928182 85.344289,70.8937182 86.601289,73.3186182 C88.146289,76.3053182 84.614289,78.8361182 84.940289,79.8411182 C85.272289,80.8431182 88.249289,85.2281182 89.024289,85.3411182 C89.804289,85.4561182 104.715289,78.7451182 97.951289,61.6434182 C94.832289,53.7590182 81.304289,50.9390182 72.392689,59.7901182 L72.397889,59.7915182 Z"
                id="Path"
                fill="#323232"
              />
              <path
                d="M82.160289,46.5933182 C81.041289,51.3190182 83.287289,54.9670182 87.580289,55.9916182 C91.867289,57.0148182 94.557289,54.3918182 95.682289,49.6674182 C96.801289,44.9417182 95.384289,40.8538182 91.091289,39.8292182 C86.799289,38.8047182 83.281289,41.8623182 82.162289,46.5881182 L82.160289,46.5933182 Z"
                id="Path"
                fill="#323232"
              />
              <path
                d="M75.066089,91.9801182 L118.595289,92.9201182 C118.595289,92.9201182 119.959289,121.073118 99.075289,116.762118 C78.194189,112.458118 75.071289,91.9811182 75.071289,91.9811182 L75.066089,91.9801182 Z"
                id="Path"
                fill="#66AFFF"
              />
              <path
                d="M86.567289,93.6761182 C92.347289,95.6181182 97.739289,98.5971182 98.555289,110.728118 C99.861289,127.488118 96.546289,155.192118 83.145289,205.859118 L40.009489,175.012118 C51.888289,150.392118 63.775789,97.8651182 75.064589,91.9851182 C79.257289,91.4071182 81.658289,92.0301182 86.565289,93.6821182 L86.567289,93.6761182 Z"
                id="Path"
                fill="#66AFFF"
              />
            </g>
          </g>
        </g>
        <g id="Clipped" transform="translate(16.115217, 154.146512)">
          <mask id="mask-4" fill="white">
            <use
              xlinkHref="#path-3"
              transform="translate(37.865143, 37.912194) rotate(-11.070534) translate(-37.865143, -37.912194) "
            />
          </mask>
          <g
            id="Oval"
            transform="translate(37.865143, 37.912194) rotate(-11.070534) translate(-37.865143, -37.912194) "
          />
          <g id="Group" mask="url(#mask-4)" fillRule="nonzero">
            <g transform="translate(-12.492646, -22.226369)">
              <rect
                id="Rectangle"
                fill="#B3E5C0"
                transform="translate(74.414491, 72.211749) rotate(-11.070534) translate(-74.414491, -72.211749) "
                x="10.5404923"
                y="11.1282416"
                width="127.747997"
                height="122.167014"
              />
              <path
                d="M45.1908294,49.8099572 C45.1908294,49.8099572 43.4838294,45.4259572 44.3864294,42.3309572 C45.5210294,38.4389572 50.4775294,35.8209572 55.5324294,38.3549572 C59.1063294,40.1459572 58.7836294,47.6079572 58.7836294,47.6079572 L48.8592294,45.5049572 L45.1909294,49.8099572 L45.1908294,49.8099572 Z"
                id="Path"
                fill="#323232"
              />
              <polygon
                id="Path"
                fill="#F7A283"
                points="57.9592294 61.0019572 55.2969294 64.7629572 51.4147294 62.2879572 50.6089294 55.1119572 56.0016294 54.0529572"
              />
              <path
                d="M46.1838294,48.7849572 C46.1838294,48.7849572 45.3112294,48.4359572 44.8684294,49.3529572 C44.4254294,50.2719572 45.4114294,53.1939572 46.9095294,52.8999572 C48.4076294,52.6059572 46.1832294,48.7849572 46.1832294,48.7849572 L46.1838294,48.7849572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M57.7619294,46.5109572 C57.7619294,46.5109572 58.4385294,45.8579572 59.1940294,46.5399572 C59.9493294,47.2219572 60.1380294,50.3019572 58.6399294,50.5959572 C57.1418294,50.8899572 57.7618294,46.5109572 57.7618294,46.5109572 L57.7619294,46.5109572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M57.8490294,45.6279572 C57.1904294,42.2609572 54.0453294,40.5899572 50.6966294,41.2469572 C47.3479294,41.9049572 45.0636294,44.6419572 45.7223294,48.0089572 C45.7223294,48.0089572 46.2994294,52.3559572 46.3404294,52.5659572 C46.9661294,55.7649572 51.6693294,59.0559572 54.0881294,58.5809572 C56.8804294,58.0319572 59.4697294,52.5039572 58.9956294,50.0799572 C58.9546294,49.8709572 57.8501294,45.6269572 57.8501294,45.6269572 L57.8490294,45.6279572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M54.0631294,33.2989572 C54.7278294,36.1809572 53.3425294,38.3969572 50.7258294,39.0029572 C48.1080294,39.6079572 46.4812294,38.0009572 45.8176294,35.1179572 C45.1529294,32.2349572 46.0358294,29.7519572 48.6525294,29.1469572 C51.2703294,28.5419572 53.3991294,30.4169572 54.0631294,33.2989572 Z"
                id="Path"
                fill="#323232"
              />
              <path
                d="M55.3109294,65.0309572 C58.4722294,64.4099572 59.4056294,60.9879572 58.6205294,60.9109572 C56.4035294,60.6939572 54.7793294,60.6179572 54.7793294,60.6179572 C54.7793294,60.6179572 53.0864294,61.3679572 50.8377294,62.5759572 C50.0656294,62.9899572 52.2373294,65.6349572 55.3104294,65.0309572 L55.3109294,65.0309572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M77.0201294,73.1019572 C75.5141294,70.4409572 72.7826294,65.8359572 70.1953294,63.7099572 C68.6387294,62.4309572 62.1403294,61.3669572 58.6205294,60.9109572 C58.5721294,64.0689572 52.1367294,65.3369572 50.8377294,62.5759572 C48.1273294,64.1899572 42.7549294,67.6159572 41.1084294,69.6939572 C37.4253294,74.3419572 38.0238294,83.9159572 38.0256294,85.3029572 C38.0321294,89.5869572 38.2378294,98.5799572 39.8168294,100.478957 C40.7118294,101.555957 41.8666294,102.895957 44.6261294,103.660957 L46.2586294,103.667957 L46.8967294,106.928957 L82.9388294,99.8499572 C83.8735294,98.7769572 83.8399294,94.1429572 83.4155294,91.9159572 C82.5921294,87.5979572 79.4373294,77.3709572 77.0207294,73.1019572 L77.0201294,73.1019572 Z"
                id="Path"
                fill="#282644"
              />
              <path
                d="M79.3695294,84.3039572 C89.8826294,74.9669572 73.9814294,48.6369572 73.9814294,48.6369572 C73.9814294,48.6369572 61.2195294,47.8789572 60.4984294,51.3479572 C57.7947294,64.3339572 51.6541294,84.4979572 56.1483294,90.4679572 C61.8645294,86.2739572 76.3893294,86.9519572 79.3694294,84.3039572 L79.3695294,84.3039572 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M61.5368294,57.4669572 C61.5368294,57.4669572 59.8298294,53.0829572 60.7323294,49.9879572 C61.8669294,46.0959572 66.9416294,43.0769572 71.8784294,46.0119572 C75.3155294,48.0549572 75.1296294,55.2649572 75.1296294,55.2649572 L65.2052294,53.1619572 L61.5369294,57.4669572 L61.5368294,57.4669572 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M74.5777294,69.5449572 C74.5777294,69.5449572 70.9985294,72.1639572 67.9004294,70.6589572 L66.9550294,62.7689572 L72.3483294,61.7099572 L74.5777294,69.5449572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M62.5298294,56.4429572 C62.5298294,56.4429572 61.6571294,56.0929572 61.2145294,57.0109572 C60.7713294,57.9279572 61.7573294,60.8509572 63.2554294,60.5569572 C64.7535294,60.2629572 62.5292294,56.4419572 62.5292294,56.4419572 L62.5298294,56.4429572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M74.1074294,54.1679572 C74.1074294,54.1679572 74.7839294,53.5149572 75.5395294,54.1969572 C76.2946294,54.8789572 76.4834294,57.9589572 74.9853294,58.2529572 C73.4872294,58.5469572 74.1073294,54.1679572 74.1073294,54.1679572 L74.1074294,54.1679572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M74.1952294,53.2859572 C73.5365294,49.9189572 70.3913294,48.2469572 67.0427294,48.9049572 C63.6940294,49.5629572 61.4096294,52.2999572 62.0685294,55.6679572 C62.0685294,55.6679572 62.6456294,60.0149572 62.6865294,60.2239572 C63.3122294,63.4219572 68.0155294,66.7139572 70.4342294,66.2389572 C73.2266294,65.6909572 75.8159294,60.1619572 75.3416294,57.7379572 C75.3009294,57.5299572 74.1962294,53.2859572 74.1962294,53.2859572 L74.1952294,53.2859572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M71.6823294,72.8189572 C74.8436294,72.1979572 75.7770294,68.7759572 74.9919294,68.6989572 C72.7749294,68.4819572 71.1507294,68.4059572 71.1507294,68.4059572 C71.1507294,68.4059572 69.4578294,69.1559572 67.2091294,70.3629572 C66.4370294,70.7779572 68.6087294,73.4219572 71.6818294,72.8189572 L71.6823294,72.8189572 Z"
                id="Path"
                fill="#F7A283"
              />
              <path
                d="M99.7864294,99.7029572 C98.9634294,95.3849572 95.8084294,85.1589572 93.3914294,80.8889572 C91.8855294,78.2289572 89.1540294,73.6229572 86.5668294,71.4979572 C85.0102294,70.2189572 78.5118294,69.1549572 74.9919294,68.6989572 C74.9436294,71.8569572 68.5082294,73.1249572 67.2091294,70.3629572 C64.4987294,71.9769572 59.1264294,75.4039572 57.4799294,77.4809572 C53.7968294,82.1299572 54.3953294,91.7029572 54.3971294,93.0899572 C54.4036294,97.3749572 54.6093294,106.367957 56.1882294,108.266957 C56.5106294,108.654957 56.8670294,109.076957 57.3194294,109.493957 L99.9614294,101.117957 C99.9274294,100.619957 99.8694294,100.139957 99.7864294,99.7039572 L99.7864294,99.7029572 Z"
                id="Path"
                fill="#F16431"
              />
              <path
                d="M30.0546294,72.3549572 C39.4776294,70.5049572 45.6190294,61.3499572 43.7719294,51.9089572 C41.9249294,42.4669572 32.7887294,36.3129572 23.3658294,38.1639572 C13.9428294,40.0149572 7.80142943,49.1689572 9.64842943,58.6109572 C11.4955294,68.0519572 20.6317294,74.2059572 30.0546294,72.3549572 Z"
                id="Path"
                fill="#151C28"
              />
              <path
                d="M21.2340294,62.2519572 C21.2340294,62.2519572 19.6226294,58.1129572 20.4737294,55.1919572 C21.5453294,51.5169572 26.3367294,48.6659572 30.9981294,51.4369572 C34.2425294,53.3659572 34.0677294,60.1729572 34.0677294,60.1729572 L24.6974294,58.1869572 L21.2339294,62.2519572 L21.2340294,62.2519572 Z"
                id="Path"
                fill="#151C28"
              />
              <path
                d="M33.2891294,72.8199572 C33.2891294,72.8199572 30.0351294,75.4549572 27.1099294,74.0339572 L26.3489294,67.2589572 L31.4413294,66.2589572 L33.2896294,72.8199572 L33.2891294,72.8199572 Z"
                id="Path"
                fill="#402014"
              />
              <path
                d="M22.1719294,61.2859572 C22.1719294,61.2859572 21.3480294,60.9559572 20.9298294,61.8229572 C20.5119294,62.6889572 21.4434294,65.4489572 22.8569294,65.1709572 C24.2704294,64.8929572 22.1719294,61.2859572 22.1719294,61.2859572 Z"
                id="Path"
                fill="#402014"
              />
              <path
                d="M33.1029294,59.1389572 C33.1029294,59.1389572 33.7415294,58.5209572 34.4550294,59.1659572 C35.1683294,59.8099572 35.3459294,62.7179572 33.9319294,62.9949572 C32.5179294,63.2729572 33.1029294,59.1389572 33.1029294,59.1389572 Z"
                id="Path"
                fill="#402014"
              />
              <path
                d="M33.1857294,58.3049572 C32.5638294,55.1259572 29.5939294,53.5479572 26.4326294,54.1689572 C23.2712294,54.7899572 21.1146294,57.3739572 21.7365294,60.5539572 C21.7365294,60.5539572 22.2813294,64.6579572 22.3197294,64.8549572 C22.9106294,67.8749572 27.3506294,70.9829572 29.6342294,70.5339572 C32.2702294,70.0169572 34.7151294,64.7969572 34.2674294,62.5079572 C34.2289294,62.3119572 33.1857294,58.3049572 33.1857294,58.3049572 Z"
                id="Path"
                fill="#402014"
              />
              <path
                d="M23.1474294,66.9519572 C23.1846294,66.9339572 23.2199294,66.9139572 23.2555294,66.8929572 L23.0526294,66.5929572 C23.0319294,66.6049572 23.0106294,66.6169572 22.9897294,66.6279572 C22.3884294,66.9239572 21.6574294,66.6739572 21.3621294,66.0709572 C21.0664294,65.4689572 21.3160294,64.7369572 21.9173294,64.4409572 L21.7591294,64.1179572 C20.9785294,64.5019572 20.6548294,65.4499572 21.0380294,66.2309572 C21.4210294,67.0129572 22.3678294,67.3359572 23.1485294,66.9519572 L23.1474294,66.9519572 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M34.2214294,64.7769572 C34.1725294,64.7739572 34.1242294,64.7679572 34.0764294,64.7589572 C34.1134294,64.7649572 34.1609294,64.4079572 34.1609294,64.4079572 C34.1891294,64.4119572 34.2180294,64.4149572 34.2463294,64.4169572 C34.9155294,64.4629572 35.4974294,63.9559572 35.5437294,63.2849572 C35.5912294,62.6159572 35.0843294,62.0329572 34.4155294,61.9859572 L34.4405294,61.6269572 C35.3082294,61.6879572 35.9645294,62.4419572 35.9044294,63.3109572 C35.8436294,64.1799572 35.0890294,64.8369572 34.2214294,64.7769572 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M30.8017294,76.8299572 C33.9631294,76.2089572 34.8964294,72.7859572 34.1114294,72.7099572 C31.8943294,72.4929572 30.2701294,72.4169572 30.2701294,72.4169572 C30.2701294,72.4169572 28.5772294,73.1669572 26.3285294,74.3739572 C25.5565294,74.7879572 27.7281294,77.4329572 30.8012294,76.8299572 L30.8017294,76.8299572 Z"
                id="Path"
                fill="#402014"
              />
              <path
                d="M58.9063294,103.713957 C58.0829294,99.3949572 54.9280294,89.1679572 52.5115294,84.8999572 C51.0055294,82.2389572 48.2740294,77.6339572 45.6868294,75.5079572 C44.1301294,74.2289572 37.6317294,73.1649572 34.1119294,72.7089572 C34.0635294,75.8669572 27.6281294,77.1349572 26.3291294,74.3739572 C23.6187294,75.9879572 18.2464294,79.4139572 16.5998294,81.4919572 C12.9167294,86.1399572 13.5152294,95.7139572 13.5170294,97.1009572 C13.5212294,100.047957 13.9479294,107.969957 14.7280294,113.247957 L59.0301294,104.545957 C58.9981294,104.256957 58.9568294,103.976957 58.9064294,103.713957 L58.9063294,103.713957 Z"
                id="Path"
                fill="#6E41CF"
              />
            </g>
          </g>
        </g>
        <polygon
          id="Path"
          fill="#FFCF00"
          fillRule="nonzero"
          points="69.8113 59.663 95.9948 70.7754 85.67 44.2263 104.317 22.687 75.939 24.3308 61.2755 -7.10542736e-15 54.0242 27.4786 26.3283 33.8892 50.2632 49.3121 47.7979 77.6984"
        />
        <polygon
          id="Path"
          fill="#FFCF00"
          fillRule="nonzero"
          points="47.6278 135.5341 65.9319 143.3021 58.7141 124.7421 71.7496 109.6851 51.9114 110.8341 41.6606 93.8251 36.5914 113.0351 17.23 117.5161 33.9622 128.2981 32.2388 148.1421"
        />
        <g id="Clipped" transform="translate(153.687523, 79.954355)">
          <mask id="mask-6" fill="white">
            <use
              xlinkHref="#path-5"
              transform="translate(34.709222, 34.767605) rotate(4.529305) translate(-34.709222, -34.767605) "
            />
          </mask>
          <g
            id="Oval"
            transform="translate(34.709222, 34.767605) rotate(4.529305) translate(-34.709222, -34.767605) "
          />
          <g id="Group" mask="url(#mask-6)">
            <g transform="translate(-13.863936, -13.052147)">
              <rect
                id="Rectangle"
                fill="#16C0E6"
                fillRule="nonzero"
                transform="translate(68.494493, 65.939963) rotate(4.529305) translate(-68.494493, -65.939963) "
                x="4.62451558"
                y="4.85297668"
                width="127.739956"
                height="122.173972"
              />
              <path
                d="M54.1364134,31.7678918 C53.6414134,38.0178918 48.3714134,42.6988918 42.3684134,42.2208918 C36.3654134,41.7438918 31.8974134,36.2888918 32.3924134,30.0378918 C32.8874134,23.7878918 38.1564134,19.1078918 44.1614134,19.5848918 C50.1664134,20.0628918 54.6314134,25.5168918 54.1364134,31.7678918 Z"
                id="Path"
                fill="#FFFFFF"
                fillRule="nonzero"
              />
              <path
                d="M45.0864134,45.3608918 C45.0864134,45.3608918 42.8824134,46.9748918 39.7834134,44.9388918 L40.7034134,39.2548918 L45.0734134,39.6028918 L45.0864134,45.3608918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M48.2984134,33.5288918 C48.5144134,30.8008918 46.5154134,28.1038918 43.8024134,27.8878918 C41.0884134,27.6718918 38.6894134,30.0198918 38.4734134,32.7478918 C38.4734134,32.7478918 38.0834134,36.2508918 38.0704134,36.4198918 C37.8654134,39.0118918 40.6714134,42.5118918 42.6314134,42.6678918 C44.8934134,42.8478918 47.9864134,39.1258918 48.1424134,37.1618918 C48.1554134,36.9928918 48.2984134,33.5288918 48.2984134,33.5288918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M38.1774134,35.4268918 C38.1774134,35.4268918 39.1134134,39.0498918 39.9034134,39.3568918 C40.6934134,39.6648918 41.2344134,38.4388918 42.9544134,38.5978918 C44.6734134,38.7578918 44.7594134,39.7828918 45.7354134,39.7888918 C46.7114134,39.7948918 48.1774134,36.4038918 48.1774134,36.4038918 C48.1774134,36.4038918 48.1564134,38.2678918 47.7684134,39.2488918 C47.4704134,40.0008918 46.9124134,41.3458918 46.2814134,41.8488918 C45.4834134,42.4868918 43.5924134,43.6178918 42.5734134,43.5628918 C41.5704134,43.5088918 39.8044134,42.0578918 39.1394134,41.3048918 C38.6124134,40.7078918 38.2734134,39.2178918 38.1044134,38.4388918 C37.8584134,37.3078918 38.1774134,35.4258918 38.1774134,35.4258918 L38.1774134,35.4268918 Z"
                id="Path"
                fill="#323232"
                fillRule="nonzero"
              />
              <polygon
                id="Path"
                fill="#FFFFFF"
                fillRule="nonzero"
                points="37.4974134 33.8628918 49.2404134 23.2968918 41.2794134 21.9908918 34.8394134 26.9838918"
              />
              <polygon
                id="Path"
                fill="#FFFFFF"
                fillRule="nonzero"
                points="44.3864134 25.6018918 50.5784134 29.4598918 49.1774134 35.3268918 42.4824134 26.0628918"
              />
              <path
                d="M42.2744134,47.7448918 C44.8854134,47.9518918 46.3614134,45.5028918 45.7634134,45.2728918 C44.0754134,44.6218918 42.8194134,44.2088918 42.8194134,44.2088918 C42.8194134,44.2088918 41.3304134,44.4208918 39.3064134,44.8668918 C38.6114134,45.0198918 39.7354134,47.5428918 42.2744134,47.7448918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M57.3124134,58.6228918 C56.7194134,56.2168918 55.5944134,52.0248918 54.0434134,49.7998918 C53.1104134,48.4608918 48.2834134,46.2098918 45.6434134,45.0838918 C44.9194134,47.5388918 39.6344134,47.1218918 39.2244134,44.6818918 C36.7644134,45.3488918 31.8374134,46.8498918 30.1044134,48.1118918 C26.2264134,50.9348918 24.6104134,58.5388918 24.3104134,59.6228918 C23.3834134,62.9688918 21.5884134,70.0338918 22.4034134,71.8618918 C22.8664134,72.8978918 23.4734134,74.1958918 25.4544134,75.3968918 L26.7234134,75.7588918 L26.5934134,77.4108918 L56.1834134,79.7648918 C57.1444134,79.1308918 58.0444134,76.5398918 58.1984134,74.7088918 C58.4964134,71.1568918 58.2654134,62.4848918 57.3124134,58.6238918 L57.3124134,58.6228918 Z"
                id="Path"
                fill="#FFEC99"
                fillRule="nonzero"
              />
              <path
                d="M70.7764134,53.5578918 C70.7764134,53.5578918 68.5424134,55.1928918 65.4034134,53.1308918 L66.3354134,47.3698918 L70.7634134,47.7218918 L70.7764134,53.5578918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M63.2294134,42.5808918 C63.2294134,42.5808918 62.8534134,38.7968918 64.2284134,36.5858918 C65.9574134,33.8038918 70.5694134,32.6528918 73.7674134,35.9218918 C75.8224134,38.0218918 74.2874134,43.8328918 74.2874134,43.8328918 L67.0204134,40.0308918 L63.2294134,42.5808918 Z"
                id="Path"
                fill="#FFFFFF"
                fillRule="nonzero"
              />
              <path
                d="M64.2664134,41.4808918 C64.2664134,41.4808918 63.6634134,41.0188918 63.1194134,41.6358918 C62.5754134,42.2538918 62.7084134,44.7438918 63.9374134,44.8418918 C65.1664134,44.9398918 64.2664134,41.4808918 64.2664134,41.4808918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M73.7714134,42.2368918 C73.7714134,42.2368918 74.4394134,41.8758918 74.8794134,42.5708918 C75.3194134,43.2668918 74.7964134,45.7048918 73.5674134,45.6078918 C72.3374134,45.5098918 73.7714134,42.2368918 73.7714134,42.2368918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M74.0314134,41.5688918 C74.2504134,38.8048918 72.1664134,36.8178918 69.4164134,36.5988918 C66.6664134,36.3808918 64.2954134,38.0128918 64.0764134,40.7768918 C64.0764134,40.7768918 63.5804134,44.2868918 63.5674134,44.4578918 C63.3594134,47.0838918 66.3034134,50.6718918 68.2894134,50.8298918 C70.5814134,51.0118918 73.7984134,47.2738918 73.9554134,45.2838918 C73.9694134,45.1128918 74.0314134,41.5688918 74.0314134,41.5688918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M67.9394134,55.9688918 C70.5504134,56.1768918 72.0274134,53.7278918 71.4294134,53.4968918 C69.7404134,52.8458918 68.4854134,52.4328918 68.4854134,52.4328918 C68.4854134,52.4328918 66.9964134,52.6448918 64.9724134,53.0908918 C64.2774134,53.2438918 65.4014134,55.7668918 67.9394134,55.9688918 L67.9394134,55.9688918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M82.9584134,67.0868918 C82.3644134,64.6968918 81.2374134,60.5308918 79.6854134,58.3198918 C78.7514134,56.9898918 73.9244134,54.7508918 71.2834134,53.6318918 C70.5604134,56.0688918 65.2764134,55.6528918 64.8644134,53.2288918 C62.4044134,53.8898918 57.4794134,55.3778918 55.7464134,56.6308918 C51.8704134,59.4338918 50.2584134,66.9858918 49.9584134,68.0618918 C49.0334134,71.3858918 47.2424134,78.4028918 48.0584134,80.2188918 C48.5214134,81.2488918 49.1294134,82.5388918 51.1114134,83.7328918 L52.3804134,84.0928918 L51.8484134,90.8088918 L81.4394134,93.1618918 C82.3994134,92.5338918 83.7004134,84.8848918 83.8534134,83.0658918 C84.1494134,79.5388918 83.9134134,70.9228918 82.9594134,67.0868918 L82.9584134,67.0868918 Z"
                id="Path"
                fill="#F16431"
                fillRule="nonzero"
              />
              <path
                d="M33.4704134,72.8228918 C43.6814134,67.8498918 37.0264134,43.8888918 37.0264134,43.8888918 C37.0264134,43.8888918 27.2594134,40.5148918 25.9444134,43.0568918 C21.0184134,52.5738918 11.8574134,66.9278918 14.0584134,72.5548918 C19.4184134,70.5378918 30.5754134,74.2338918 33.4704134,72.8228918 L33.4704134,72.8228918 Z"
                id="Path"
                fill="#D6D6D6"
                fillRule="nonzero"
              />
              <path
                d="M25.4224134,48.0458918 C25.4224134,48.0458918 25.0464134,44.2608918 26.4214134,42.0498918 C28.1504134,39.2688918 32.7554134,38.0258918 35.9604134,41.3868918 C38.1914134,43.7268918 36.4804134,49.2978918 36.4804134,49.2978918 L29.2134134,45.4958918 L25.4224134,48.0458918 L25.4224134,48.0458918 Z"
                id="Path"
                fill="#D6D6D6"
                fillRule="nonzero"
              />
              <path
                d="M32.9474134,60.2908918 C32.9474134,60.2908918 29.5934134,61.5488918 27.5084134,59.7018918 L28.4874134,53.3548918 L32.9154134,53.7068918 L32.9474134,60.2908918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M26.4184134,47.4648918 C26.4184134,47.4648918 25.8144134,47.0028918 25.2714134,47.6208918 C24.7264134,48.2378918 24.8594134,50.7278918 26.0884134,50.8258918 C27.3184134,50.9238918 26.4174134,47.4648918 26.4174134,47.4648918 L26.4184134,47.4648918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M35.9224134,48.2208918 C35.9224134,48.2208918 36.5914134,47.8598918 37.0314134,48.5558918 C37.4704134,49.2518918 36.9484134,51.6888918 35.7184134,51.5918918 C34.4884134,51.4938918 35.9224134,48.2208918 35.9224134,48.2208918 L35.9224134,48.2208918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M36.1824134,47.5538918 C36.4014134,44.7888918 34.3174134,42.8018918 31.5684134,42.5838918 C28.8194134,42.3648918 26.4464134,43.9968918 26.2274134,46.7618918 C26.2274134,46.7618918 25.7324134,50.2708918 25.7184134,50.4418918 C25.5104134,53.0678918 28.4554134,56.6558918 30.4414134,56.8138918 C32.7334134,56.9968918 35.9504134,53.2588918 36.1074134,51.2688918 C36.1214134,51.0978918 36.1834134,47.5538918 36.1834134,47.5538918 L36.1824134,47.5538918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M29.9824134,62.2068918 C32.5784134,62.4138918 34.0484134,59.9538918 33.4534134,59.7228918 C31.7754134,59.0698918 30.5284134,58.6568918 30.5284134,58.6568918 C30.5284134,58.6568918 29.0474134,58.8708918 27.0354134,59.3198918 C26.3444134,59.4738918 27.4594134,62.0068918 29.9824134,62.2068918 L29.9824134,62.2068918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M46.0134134,89.2618918 C46.3114134,85.7208918 46.0784134,77.0738918 45.1254134,73.2238918 C44.5314134,70.8248918 43.4054134,66.6448918 41.8544134,64.4258918 C40.9204134,63.0908918 36.0944134,60.8448918 33.4534134,59.7228918 C32.7304134,62.1698918 27.4464134,61.7528918 27.0354134,59.3208918 C24.5754134,59.9848918 19.6494134,61.4798918 17.9164134,62.7378918 C14.0404134,65.5518918 12.4254134,73.1328918 12.1254134,74.2128918 C11.1994134,77.5488918 9.40541336,84.5928918 10.2224134,86.4158918 C10.3884134,86.7878918 10.5744134,87.1938918 10.8354134,87.6168918 L45.8424134,90.4008918 C45.9244134,90.0058918 45.9834134,89.6188918 46.0134134,89.2618918 L46.0134134,89.2618918 Z"
                id="Path"
                fill="#F16431"
                fillRule="nonzero"
              />
              <path
                d="M49.0694134,47.0758918 C49.0694134,47.0758918 48.6934134,43.2918918 50.0674134,41.0798918 C51.7964134,38.2978918 57.9254134,36.0158918 59.5644134,37.1998918 C61.2034134,38.3848918 58.1784134,39.7868918 58.9514134,40.1828918 C59.7244134,40.5798918 60.5884134,38.7698918 61.0664134,39.2268918 C63.0054134,41.0818918 60.1264134,48.3268918 60.1264134,48.3268918 L52.8594134,44.5258918 L49.0694134,47.0758918 L49.0694134,47.0758918 Z"
                id="Path"
                fill="#323232"
                fillRule="nonzero"
              />
              <polygon
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
                points="56.5744134 58.5718918 53.6854134 60.9178918 51.2014134 58.1448918 52.1334134 52.3828918 56.5614134 52.7358918"
              />
              <path
                d="M50.0644134,46.4948918 C50.0644134,46.4948918 49.4604134,46.0328918 48.9174134,46.6498918 C48.3734134,47.2678918 48.5054134,49.7588918 49.7354134,49.8558918 C50.9654134,49.9538918 50.0644134,46.4948918 50.0644134,46.4948918 L50.0644134,46.4948918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M59.5694134,47.2508918 C59.5694134,47.2508918 60.2374134,46.8898918 60.6784134,47.5848918 C61.1174134,48.2818918 60.5944134,50.7198918 59.3654134,50.6218918 C58.1354134,50.5248918 59.5694134,47.2508918 59.5694134,47.2508918 L59.5694134,47.2508918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M59.8294134,46.5818918 C60.0484134,43.8188918 57.9644134,41.8318918 55.2144134,41.6128918 C52.4644134,41.3938918 50.0924134,43.0268918 49.8734134,45.7898918 C49.8734134,45.7898918 49.3784134,49.2998918 49.3644134,49.4708918 C49.1564134,52.0978918 52.1014134,55.6858918 54.0874134,55.8438918 C56.3784134,56.0258918 59.5964134,52.2878918 59.7544134,50.2978918 C59.7674134,50.1268918 59.8294134,46.5818918 59.8294134,46.5818918 L59.8294134,46.5818918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M53.5514134,61.0208918 C56.1624134,61.2288918 57.6394134,58.7798918 57.0414134,58.5488918 C55.3524134,57.8978918 54.0974134,57.4848918 54.0974134,57.4848918 C54.0974134,57.4848918 52.6074134,57.6978918 50.5844134,58.1428918 C49.8894134,58.2958918 51.0134134,60.8188918 53.5514134,61.0208918 Z"
                id="Path"
                fill="#F7A283"
                fillRule="nonzero"
              />
              <path
                d="M52.0894134,49.1948918 C51.0214134,49.1098918 50.2214134,48.1708918 50.3064134,47.1008918 C50.3904134,46.0318918 51.3284134,45.2298918 52.3964134,45.3148918 C53.4644134,45.3998918 54.2634134,46.3388918 54.1784134,47.4088918 C54.0944134,48.4798918 53.1564134,49.2798918 52.0894134,49.1948918 Z M52.3814134,45.5058918 C51.4194134,45.4298918 50.5734134,46.1518918 50.4974134,47.1168918 C50.4214134,48.0808918 51.1414134,48.9278918 52.1044134,49.0038918 C53.0674134,49.0808918 53.9114134,48.3588918 53.9874134,47.3938918 C54.0644134,46.4298918 53.3434134,45.5828918 52.3814134,45.5058918 Z"
                id="Shape"
                fill="#282644"
                fillRule="nonzero"
              />
              <g
                id="Clipped"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                transform="translate(50.300220, 45.308713)"
              >
                <mask id="mask-8" fill="white">
                  <use xlinkHref="#path-7" />
                </mask>
                <g id="Shape" />
                <path
                  d="M1.86819299,2.88917905 C1.35219299,2.84817905 0.961192989,2.39217905 1.00319299,1.87217905 L-0.990807011,1.71317905 C-1.11880701,3.33217905 0.0901929887,4.75417905 1.71019299,4.88317905 L1.86819299,2.88917905 Z M1.00319299,1.87217905 C1.04419299,1.35117905 1.50219299,0.962179049 2.01719299,1.00317905 L2.17519299,-0.990820951 C0.554192989,-1.11982095 -0.862807011,0.0961790489 -0.990807011,1.71317905 L1.00319299,1.87217905 Z M2.01719299,1.00317905 C2.53219299,1.04417905 2.92319299,1.49917905 2.88219299,2.02117905 L4.87519299,2.18017905 C5.00319299,0.561179049 3.79619299,-0.861820951 2.17519299,-0.990820951 L2.01719299,1.00317905 Z M2.88219299,2.02117905 C2.84019299,2.54217905 2.38319299,2.93017905 1.86819299,2.88917905 L1.71019299,4.88317905 C3.32919299,5.01217905 4.74719299,3.79917905 4.87519299,2.18017905 L2.88219299,2.02117905 Z M2.16019299,-0.798820951 C0.645192989,-0.919820951 -0.679807011,0.215179049 -0.799807011,1.72817905 L1.19419299,1.88717905 C1.22719299,1.47117905 1.59219299,1.16217905 2.00219299,1.19417905 L2.16019299,-0.798820951 Z M-0.799807011,1.72817905 C-0.919807011,3.24217905 0.210192989,4.57217905 1.72519299,4.69217905 L1.88319299,2.69817905 C1.47219299,2.66617905 1.16119299,2.30317905 1.19419299,1.88717905 L-0.799807011,1.72817905 Z M1.72519299,4.69217905 C3.24019299,4.81317905 4.56419299,3.67717905 4.68419299,2.16517905 L2.69019299,2.00617905 C2.65719299,2.42217905 2.29319299,2.73117905 1.88319299,2.69817905 L1.72519299,4.69217905 Z M4.68419299,2.16517905 C4.80419299,0.652179049 3.67419299,-0.678820951 2.16019299,-0.798820951 L2.00219299,1.19417905 C2.41119299,1.22717905 2.72319299,1.59017905 2.69019299,2.00617905 L4.68419299,2.16517905 Z"
                  id="Shape"
                  fill="#000000"
                  fillRule="nonzero"
                  mask="url(#mask-8)"
                />
              </g>
              <path
                d="M57.2524134,49.6058918 C56.1844134,49.5208918 55.3854134,48.5818918 55.4694134,47.5118918 C55.5544134,46.4418918 56.4924134,45.6408918 57.5604134,45.7258918 C58.6284134,45.8098918 59.4274134,46.7498918 59.3424134,47.8198918 C59.2574134,48.8898918 58.3204134,49.6908918 57.2524134,49.6058918 Z M57.5444134,45.9168918 C56.5824134,45.8408918 55.7374134,46.5628918 55.6614134,47.5268918 C55.5854134,48.4918918 56.3054134,49.3378918 57.2674134,49.4138918 C58.2304134,49.4908918 59.0754134,48.7688918 59.1514134,47.8048918 C59.2284134,46.8408918 58.5064134,45.9938918 57.5444134,45.9168918 Z"
                id="Shape"
                fill="#282644"
                fillRule="nonzero"
              />
              <g
                id="Clipped"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                transform="translate(55.463352, 45.719706)"
              >
                <mask id="mask-10" fill="white">
                  <use xlinkHref="#path-9" />
                </mask>
                <g id="Shape" />
                <path
                  d="M1.86806097,2.88918584 C1.35306097,2.84818584 0.962060975,2.39218584 1.00306097,1.87118584 L-0.990939025,1.71318584 C-1.11893903,3.33118584 0.090060975,4.75418584 1.71006097,4.88318584 L1.86806097,2.88918584 Z M1.00306097,1.87118584 C1.04406097,1.35018584 1.50206097,0.961185837 2.01806097,1.00218584 L2.17606097,-0.990814163 C0.555060975,-1.11981416 -0.861939025,0.0941858367 -0.990939025,1.71318584 L1.00306097,1.87118584 Z M2.01806097,1.00218584 C2.53306097,1.04318584 2.92306097,1.49918584 2.88206097,2.02118584 L4.87606097,2.17918584 C5.00406097,0.561185837 3.79606097,-0.861814163 2.17606097,-0.990814163 L2.01806097,1.00218584 Z M2.88206097,2.02118584 C2.84106097,2.54218584 2.38306097,2.93018584 1.86806097,2.88918584 L1.71006097,4.88318584 C3.33006097,5.01218584 4.74806097,3.79818584 4.87606097,2.17918584 L2.88206097,2.02118584 Z M2.16006097,-0.799814163 C0.646060975,-0.919814163 -0.678939025,0.215185837 -0.798939025,1.72818584 L1.19506097,1.88618584 C1.22806097,1.47018584 1.59306097,1.16118584 2.00206097,1.19418584 L2.16006097,-0.799814163 Z M-0.798939025,1.72818584 C-0.918939025,3.24118584 0.211060975,4.57118584 1.72506097,4.69118584 L1.88306097,2.69718584 C1.47306097,2.66518584 1.16206097,2.30218584 1.19506097,1.88618584 L-0.798939025,1.72818584 Z M1.72506097,4.69118584 C3.24006097,4.81218584 4.56506097,3.67718584 4.68506097,2.16418584 L2.69106097,2.00518584 C2.65906097,2.42118584 2.29406097,2.73018584 1.88306097,2.69718584 L1.72506097,4.69118584 Z M4.68506097,2.16418584 C4.80506097,0.651185837 3.67406097,-0.678814163 2.16006097,-0.799814163 L2.00206097,1.19418584 C2.41206097,1.22718584 2.72406097,1.59018584 2.69106097,2.00518584 L4.68506097,2.16418584 Z"
                  id="Shape"
                  fill="#000000"
                  fillRule="nonzero"
                  mask="url(#mask-10)"
                />
              </g>
              <polygon
                id="Path"
                fill="#282644"
                fillRule="nonzero"
                points="55.4954134 47.1878918 54.2044134 47.0858918 54.1784134 47.4088918 55.4694134 47.5118918"
              />
              <g
                id="Clipped"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
                transform="translate(54.178413, 46.798892)"
              >
                <mask id="mask-12" fill="white">
                  <use xlinkHref="#path-11" />
                </mask>
                <g id="Path" />
                <path
                  d="M0.026,0.287 L0.105,-0.71 L-0.892,-0.789 L-0.971,0.207 L0.026,0.287 Z M1.317,0.389 L2.314,0.469 L2.393,-0.528 L1.396,-0.608 L1.317,0.389 Z M1.291,0.713 L1.212,1.71 L2.209,1.789 L2.288,0.792 L1.291,0.713 Z M0,0.61 L-0.996,0.531 L-1.075,1.528 L-0.078,1.607 L0,0.61 Z M-0.053,1.284 L1.238,1.386 L1.396,-0.608 L0.105,-0.71 L-0.053,1.284 Z M0.32,0.31 L0.295,0.633 L2.288,0.792 L2.314,0.469 L0.32,0.31 Z M1.37,-0.284 L0.079,-0.387 L-0.078,1.607 L1.212,1.71 L1.37,-0.284 Z M0.997,0.689 L1.023,0.366 L-0.971,0.207 L-0.996,0.531 L0.997,0.689 Z"
                  id="Shape"
                  fill="#000000"
                  fillRule="nonzero"
                  mask="url(#mask-12)"
                />
              </g>
              <path
                d="M69.8064134,87.9098918 C70.1034134,84.3718918 69.8694134,75.7288918 68.9164134,71.8808918 C68.3214134,69.4828918 67.1954134,65.3048918 65.6434134,63.0868918 C64.7094134,61.7528918 59.8814134,59.5078918 57.2404134,58.3858918 C56.5164134,60.8318918 51.2304134,60.4148918 50.8194134,57.9828918 C48.3584134,58.6478918 43.4314134,60.1408918 41.6984134,61.3978918 C37.8204134,64.2108918 36.2064134,71.7878918 35.9064134,72.8668918 C35.2894134,75.0888918 33.9124134,81.1238918 33.3044134,85.4428918 L69.7584134,88.3428918 C69.7784134,88.1948918 69.7944134,88.0498918 69.8064134,87.9098918 Z"
                id="Path"
                fill="#D0F2FA"
                fillRule="nonzero"
              />
            </g>
          </g>
        </g>
        <g id="Clipped" transform="translate(86.866712, 137.978619)">
          <mask id="mask-14" fill="white">
            <use
              xlinkHref="#path-13"
              transform="translate(25.954332, 25.997936) rotate(4.529305) translate(-25.954332, -25.997936) "
            />
          </mask>
          <g
            id="Oval"
            transform="translate(25.954332, 25.997936) rotate(4.529305) translate(-25.954332, -25.997936) "
          />
          <g id="Group" mask="url(#mask-14)" fillRule="nonzero">
            <g transform="translate(-10.367003, -9.760632)">
              <rect
                id="Rectangle"
                fill="#F3F6D3"
                transform="translate(51.217783, 49.307576) rotate(4.529305) translate(-51.217783, -49.307576) "
                x="3.45804927"
                y="3.62888613"
                width="95.5194669"
                height="91.357379"
              />
              <path
                d="M27.0152903,52.4821133 C27.0152903,52.4821133 18.9442903,57.1041133 14.9537903,79.4391133 C12.1570903,95.0841133 10.3822903,100.520113 10.3822903,100.520113 L14.8895903,100.944113 C14.8895903,100.944113 25.4602903,79.5601133 27.0352903,69.8211133 C27.7762903,65.2231133 27.0142903,52.4901133 27.0142903,52.4901133 L27.0152903,52.4821133 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M43.5092903,53.5881133 C43.5092903,53.5881133 52.1212903,57.7721133 52.1802903,81.7591133 C52.2162903,97.6461133 53.0562903,103.913113 53.0562903,103.913113 L48.5382903,103.620113 C48.5382903,103.620113 41.4662903,80.8331133 41.4442673,70.9671133 C41.4362903,66.3101133 43.5182903,53.5891133 43.5182903,53.5891133 L43.5092903,53.5881133 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M33.0702903,51.0661133 C30.1722903,51.0161133 26.9552903,51.2701133 25.8282903,54.2191133 C24.9082903,58.2851133 25.8292903,71.5901133 22.2802903,84.8431133 C17.2854903,103.500113 16.4094903,124.078113 16.4094903,124.078113 L43.9492903,126.473113 C43.9492903,126.473113 45.9402903,105.787113 44.5982903,86.8231133 C43.6892903,73.9881133 46.2692903,61.5941133 44.9382903,55.7311133 C44.2402903,52.6441133 39.7592903,51.9921133 38.2582903,51.4791133 C36.4712903,50.5561133 35.5342903,51.1061133 33.0702903,51.0661133 L33.0702903,51.0661133 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M54.1372903,34.9111133 C53.3782903,44.4931133 45.0082903,51.6461133 35.4452903,50.8851133 C25.8822903,50.1251133 18.7434903,41.7381133 19.5024903,32.1571133 C20.2612903,22.5751133 28.6312903,15.4221133 38.1942903,16.1821133 C47.7572903,16.9431133 54.8962903,25.3291133 54.1372903,34.9111133 L54.1372903,34.9111133 Z"
                id="Path"
                fill="#323232"
              />
              <path
                d="M31.0072903,40.3731133 C31.0072903,40.3731133 30.6412903,36.7131133 31.9742903,34.5771133 C33.6462903,31.8931133 38.0932903,30.6951133 41.1892903,33.9391133 C43.3462903,36.1961133 41.6912903,41.5761133 41.6912903,41.5761133 L34.6702903,37.9041133 L31.0082903,40.3651133 L31.0072903,40.3731133 Z"
                id="Path"
                fill="#323232"
              />
              <path
                d="M38.2592903,51.4791133 C38.2592903,51.4791133 35.0842903,52.8521133 33.0702903,51.0661133 L33.9702903,45.5031133 L38.2462903,45.8431133 L38.2592903,51.4791133 L38.2592903,51.4791133 Z"
                id="Path"
                fill="#653D2E"
              />
              <path
                d="M31.9692903,39.8171133 C31.9692903,39.8171133 31.3902903,39.3681133 30.8592903,39.9661133 C30.3362903,40.5651133 30.4662903,42.9661133 31.6472903,43.0601133 C32.8282903,43.1541133 31.9612903,39.8161133 31.9612903,39.8161133 L31.9692903,39.8171133 Z"
                id="Path"
                fill="#653D2E"
              />
              <path
                d="M41.1492903,40.5461133 C41.1492903,40.5461133 41.7922903,40.1951133 42.2222903,40.8701133 C42.6442903,41.5441133 42.1462903,43.8951133 40.9572903,43.8001133 C39.7682903,43.7051133 41.1572903,40.5471133 41.1572903,40.5471133 L41.1492903,40.5461133 Z"
                id="Path"
                fill="#653D2E"
              />
              <path
                d="M41.3972903,39.9011133 C41.6082903,37.2321133 39.5962903,35.3141133 36.9412903,35.1031133 C34.2852903,34.8921133 31.9972903,36.4681133 31.7852903,39.1371133 C31.7852903,39.1371133 31.3042903,42.5231133 31.2902903,42.6951133 C31.0892903,45.2331133 33.9382903,48.6951133 35.8522903,48.8481133 C38.0682903,49.0241133 41.1742903,45.4111133 41.3262903,43.4931133 C41.3382903,43.3291133 41.3972903,39.9011133 41.3972903,39.9011133 L41.3972903,39.9011133 Z"
                id="Path"
                fill="#653D2E"
              />
              <path
                d="M31.4882903,44.5421133 C31.4882903,44.5421133 31.5552903,44.5311133 31.5892903,44.5171133 L31.4972903,44.2311133 C31.4972903,44.2311133 31.4552903,44.2441133 31.4382903,44.2421133 C30.8972903,44.3471133 30.3692903,43.9851133 30.2652903,43.4351133 C30.1602903,42.8921133 30.5222903,42.3631133 31.0712903,42.2591133 L31.0202903,41.9671133 C30.3132903,42.1001133 29.8412903,42.7851133 29.9742903,43.4851133 C30.1062903,44.1941133 30.7912903,44.6591133 31.4972903,44.5351133 L31.4882903,44.5421133 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M40.7902903,45.2821133 C40.7902903,45.2821133 40.7192903,45.2511133 40.6802903,45.2321133 C40.7122903,45.2431133 40.8232903,44.9721133 40.8232903,44.9721133 C40.8482903,44.9741133 40.8712903,44.9931133 40.8862903,45.0021133 C41.4042903,45.1911133 41.9832903,44.9171133 42.1732903,44.3901133 C42.3612903,43.8711133 42.0882903,43.2911133 41.5622903,43.1011133 L41.6572903,42.8211133 C42.3352903,43.0641133 42.6852903,43.8151133 42.4522903,44.4861133 C42.2102903,45.1651133 41.4602903,45.5161133 40.7822903,45.2811133 L40.7902903,45.2821133 Z"
                id="Path"
                fill="#FFFFFF"
              />
            </g>
          </g>
        </g>
        <g id="Clipped" transform="translate(129.924068, 1.848858)">
          <mask id="mask-16" fill="white">
            <use
              xlinkHref="#path-15"
              transform="translate(23.653482, 23.676735) rotate(15.216047) translate(-23.653482, -23.676735) "
            />
          </mask>
          <g
            id="Oval"
            transform="translate(23.653482, 23.676735) rotate(15.216047) translate(-23.653482, -23.676735) "
          />
          <g id="Group" mask="url(#mask-16)" fillRule="nonzero">
            <g transform="translate(-31.808344, -8.682201)">
              <rect
                id="Rectangle"
                fill="#A2E6F5"
                transform="translate(65.144680, 45.204170) rotate(15.216047) translate(-65.144680, -45.204170) "
                x="27.0017461"
                y="8.73238257"
                width="76.2858674"
                height="72.9435742"
              />
              <path
                d="M49.4662752,48.2587426 C45.0042752,47.3333426 39.7292752,44.3343426 34.6382752,51.8766426 C28.3922752,66.2794426 8.94927517,123.121443 8.94927517,123.121443 L50.8002752,134.884443 C50.8002752,134.884443 62.9282752,83.4793426 63.7272752,59.8080426 C63.9472752,53.2857426 60.1842752,54.2152426 58.8472752,52.4379426 C56.3572752,50.4816426 53.2652752,49.0442426 49.4712752,48.2576426 L49.4662752,48.2587426 Z"
                id="Path"
                fill="#1D9AD2"
              />
              <path
                d="M39.9732752,59.4638426 C39.9732752,59.4638426 29.9712752,50.8084426 36.0002752,43.6275426 C42.0302752,36.4466426 70.4272752,47.7049426 68.2722752,54.9137426 C66.1182752,62.1201426 50.6222752,63.4137426 50.6222752,63.4137426 L39.9752752,59.4644426 L39.9732752,59.4638426 Z"
                id="Path"
                fill="#1D9AD2"
              />
              <path
                d="M45.9742752,32.8005426 C45.9742752,32.8005426 45.8432752,27.0169426 48.1782752,23.8202426 C51.1192752,19.8000426 60.6642752,17.0435426 63.0092752,19.0268426 C65.3562752,21.0108426 60.6112752,22.7920426 61.7362752,23.4818426 C62.8612752,24.1717426 64.3772752,21.5242426 65.0512752,22.2756426 C67.7722752,25.3120426 62.5782752,35.9698426 62.5782752,35.9698426 L52.0102752,29.3685426 L45.9742752,32.8005426 L45.9742752,32.8005426 Z"
                id="Path"
                fill="#5B5B5B"
              />
              <polygon
                id="Path"
                fill="#F9C1AD"
                points="54.6442752 51.2775426 49.6722752 53.9676426 46.7472752 49.1215426 49.7612752 40.7735426 56.2722752 42.5510426"
              />
              <path
                d="M62.3302752,33.2877426 C62.9802752,29.1196426 60.0532752,25.8681426 55.9122752,25.2204426 C51.7742752,24.5733426 47.9912752,26.7766426 47.3422752,30.9423426 C47.3422752,30.9423426 46.1872752,36.2075426 46.1472752,36.4664426 C45.5282752,40.4271426 49.5742752,46.2058426 52.5642752,46.6728426 C56.0152752,47.2118426 61.3192752,41.9104426 61.7862752,38.9124426 C61.8252752,38.6536426 62.3282752,33.2846426 62.3282752,33.2846426 L62.3302752,33.2877426 Z"
                id="Path"
                fill="#F9C1AD"
              />
              <path
                d="M47.5492752,32.0339426 C47.5492752,32.0339426 46.6892752,31.2647426 45.7942752,32.1376426 C44.8982752,33.0128426 44.8112752,36.8054426 46.6622752,37.0949426 C48.5132752,37.3845426 47.5472752,32.0332426 47.5472752,32.0332426 L47.5492752,32.0339426 Z"
                id="Path"
                fill="#F9C1AD"
              />
              <path
                d="M61.8582752,34.2708426 C61.8582752,34.2708426 62.9122752,33.8010426 63.4992752,34.9065426 C64.0842752,36.0137426 63.0132752,39.6507426 61.1602752,39.3605426 C59.3092752,39.0709426 61.8582752,34.2708426 61.8582752,34.2708426 L61.8582752,34.2708426 Z"
                id="Path"
                fill="#F9C1AD"
              />
              <path
                d="M35.3552752,50.0671426 C35.3552752,50.0671426 15.7192752,54.2166426 2.25327517,85.5114426 C-8.57952483,110.686443 23.0152752,101.989443 25.8212752,95.7544426 C27.2942752,92.4814426 36.8432752,71.4736426 39.1592752,59.1363426 C40.1402752,53.9083426 35.3552752,50.0671426 35.3552752,50.0671426 L35.3552752,50.0671426 Z"
                id="Path"
                fill="#FFFFFF"
              />
              <path
                d="M66.4752752,57.7602426 L40.1522752,55.0678426 L75.5062752,88.4630426 L71.2502752,62.2710426 C70.8572752,59.8566426 68.9012752,58.0083426 66.4762752,57.7602426 L66.4752752,57.7602426 Z"
                id="Path"
                fill="#CEA23E"
              />
            </g>
          </g>
        </g>
        <polygon
          id="Path"
          fill="#FFCF00"
          fillRule="nonzero"
          points="168.028 210.6051 191.753 235.3971 192.925 201.0681 223.807 186.1001 191.594 174.3911 186.906 140.4501 165.825 167.4301 132.104 161.3261 151.291 189.8201 135.081 220.0871"
        />
        <polygon
          id="Path"
          fill="#FFCF00"
          fillRule="nonzero"
          points="164.862 78.4507 172.324 87.6921 173.725 75.8874 184.811 71.6259 174.041 66.6486 173.41 54.8066 165.357 63.4964 153.904 60.4081 159.694 70.7945 153.224 80.7599"
        />
      </g>
    </g>
  </Icon>
);

export default memo(StarredTabEmptyPlaceholderIcon);
